import { ChartOptions } from "chart.js";
import { Bar } from "react-chartjs-2";

const options3: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: "top",
            display: false,
        },
        title: {
            display: false,
            text: "Aantal werken",
        },
    },
    scales: {
        x: {
            ticks: { 
                display: true,
                font: {
                    size: 10
                },
                color: '#666',
                maxRotation: 45,
                minRotation: 45
            },
            grid: { display: false },
            border: { display: false }
        },
        y: {
            ticks: { display: false },
            grid: { display: false },
            border: { display: false }
        },
    },
};

export default function BarChart({ data }: any) {
    const chartData = {
        labels: data.map((d: any) => d.x),
        datasets: [
            {
                data: data.map((d: any) => d.y),
                backgroundColor: "#284F82",
            },
        ],
    };

    return (
        <div className="relative w-full max-h-[100px] flex items-center justify-center">
            <Bar options={options3} data={chartData} />
        </div>
    );
}
